import { useEffect } from 'react';
import { useBranding } from '#/branding/BrandingContext';
import styles from './top-bar-center.module.css';

const TopBarCenter: React.FC = () => {
  const { topBarCenter } = useBranding();
  const fontUrl = topBarCenter?.fontUrl;

  useEffect(() => {
    if (!fontUrl) return;
    const selector = `link[data-branding-font="${fontUrl}"]`;
    if (document.querySelector(selector)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontUrl;
    link.setAttribute('data-branding-font', fontUrl);
    document.head.appendChild(link);
  }, [fontUrl]);

  const handleLogoClick = () => {
    if (topBarCenter?.reloadOnClick) window.location.reload();
  };

  if (!topBarCenter) {
    return null;
  }
  else if (topBarCenter.logo) {
    const logoStyle: React.CSSProperties & Record<string, string> = {};
    if (topBarCenter.logoHeight) logoStyle['--tbc-logo-height'] = topBarCenter.logoHeight;
    if (topBarCenter.logoHeightMobile) logoStyle['--tbc-logo-height-mobile'] = topBarCenter.logoHeightMobile;

    return (
      <div className={styles.container} onClick={handleLogoClick}>
        <img src={topBarCenter.logo} className={styles.logo} style={logoStyle} alt="" />
      </div>
    );
  }
  else if (topBarCenter.text) {
    const textStyle: React.CSSProperties & Record<string, string> = {};
    if (topBarCenter.font) textStyle.fontFamily = topBarCenter.font;
    if (topBarCenter.fontWeight) textStyle.fontWeight = topBarCenter.fontWeight;
    if (topBarCenter.fontStretch) textStyle.fontStretch = topBarCenter.fontStretch;
    if (topBarCenter.letterSpacing) textStyle.letterSpacing = topBarCenter.letterSpacing;
    if (topBarCenter.color) textStyle.color = topBarCenter.color;
    if (topBarCenter.fontSize) textStyle['--tbc-font-size'] = topBarCenter.fontSize;
    if (topBarCenter.fontSizeMobile) textStyle['--tbc-font-size-mobile'] = topBarCenter.fontSizeMobile;

    return (
      <div className={styles.container}>
        <span className={styles.text} style={textStyle}>{topBarCenter.text}</span>
      </div>
    );
  }

  return null;
};

export default TopBarCenter;
